<template>
  <div class="editor-title">
    <h4>{{ t("message.LEDs") }}</h4>
  </div>

  <ul>
    <li class="editor-element">
      <!-- <input type="checkbox" checked />
      <i class="arrow"></i> -->
      <h2 class="row text-start">
        <div class="col-5">{{ t("message.keyLEDs") }}</div>
        <div class="col-7">
          <button
            class="btn btn-outline-lcn"
            v-if="!showLEDs"
            @click="toggleLEDs"
          >
            <font-awesome-icon
              :icon="['far', 'eye']"
              class="icon"
            ></font-awesome-icon>
            {{ t("message.fadeIn") }}
          </button>
        </div>
      </h2>
      <div class="content-expand">
        <div class="col-7 offset-5 text-start">
          <div class="row pb-2" v-if="showLEDs">
            <div class="col">
              {{ t("message.round") }}
              <input
                type="radio"
                class="form-check-input"
                value=""
                name="radius"
                @change="changeRad(4)"
              />
              {{ t("message.angled") }}
              <input
                type="radio"
                class="form-check-input"
                value=""
                name="radius"
                :disabled="!showLEDs"
                checked
                @change="changeRad(0)"
              />
            </div>
          </div>
          <div class="row">
            <div class="col">
              <button
                class="btn btn-outline-lcn mb-2 w-75"
                v-if="showLEDs"
                @click="hideSelectedLEDs"
              >
                <font-awesome-icon
                  :icon="['far', 'eye-slash']"
                  class="icon"
                ></font-awesome-icon>
                {{ t("message.hideSelectedLEDs") }}
              </button>
            </div>
          </div>

          <button
            class="btn btn-outline-lcn"
            v-if="showLEDs"
            @click="toggleLEDs"
          >
            <font-awesome-icon
              :icon="['far', 'eye-slash']"
              class="icon"
            ></font-awesome-icon>
            {{ t("message.fadeOut") }}
          </button>
        </div>
      </div>
    </li>
    <template v-if="!currentInlay.name.includes('gt6l')">
      <li class="topic-separator" v-if="currentInlay.inlay.bargraph.length > 0">
        <!-- <input type="checkbox" checked />
        <i class="arrow"></i> -->
        <h2 class="text-start row">
          <div class="col-5">{{ t("message.barGrLEDs") }}</div>
          <div class="col-7">
            <button
              class="btn btn-outline-lcn"
              v-if="!showBarG"
              @click="toggleBarG"
            >
              <font-awesome-icon
                :icon="['far', 'eye']"
                class="icon"
              ></font-awesome-icon>
              {{ t("message.fadeIn") }}
            </button>
          </div>
        </h2>
        <div class="content-expand">
          <template v-if="showBarG">
            <div class="col-7 offset-5">
              <label
                class="p-2 pb-1"
                for="bargraph"
                @click="changeBarGraph('BargraphLED')"
                style="cursor: pointer"
                :style="{
                  'border-bottom':
                    currentInlay.inlay.selectedBarGType == 'BargraphLED'
                      ? '1px solid #ffee00'
                      : '',
                }"
              >
                {{ t("message.separate") }}
              </label>
              <input
                class="bargraph-select"
                type="checkbox"
                name="bargraph"
                id="bargraph"
              />
              <label
                for="bargraph"
                class="p-1 pb-1"
                @click="changeBarGraph('BargraphLEDgrad')"
                style="cursor: pointer"
                :style="{
                  'border-bottom':
                    currentInlay.inlay.selectedBarGType == 'BargraphLEDgrad'
                      ? '1px solid #ffee00'
                      : '',
                }"
                >{{ t("message.continuous") }}</label
              >
              <input
                class="bargraph-select"
                type="checkbox"
                name="bargraph"
                id="bargraph"
              />
            </div>
            <div class="row mt-3">
              <div class="row text-start">
                <div class="col-5">{{ t("message.color") }}</div>
                <div class="col-7">
                  <transition name="fade">
                    <button
                      class="btn btn-outline-lcn"
                      @click="showPicker = true"
                      v-if="!showPicker"
                    >
                      <font-awesome-icon
                        :icon="['far', 'eye']"
                        class="icon"
                      ></font-awesome-icon>
                      {{ t("message.fadeIn") }}
                    </button>
                  </transition>
                </div>
              </div>
              <div>
                <transition name="fade">
                  <div v-if="showPicker">
                    <div class="color-picker-container">
                      <MyCp
                        @update="updateColor($event)"
                        @mouseup="mouseUp"
                        :id="'color-picker-inlaybg'"
                        :pColor="{
                          type: 'solid',
                          color:
                            selectedBarGLEDs.length > 0 &&
                            currentBargraph[selectedBarGLEDs[0].id].style[
                              'background-color'
                            ] !== 'white'
                              ? currentBargraph[selectedBarGLEDs[0].id].style[
                                  'background-color'
                                ]
                              : '',
                        }"
                      ></MyCp>
                    </div>
                    <div class="mt-3">
                      <button
                        class="btn btn-outline-lcn me-2"
                        @click="updateBtn('background-color', '')"
                      >
                        <font-awesome-icon
                          :icon="['fas', 'ban']"
                          class="icon"
                        ></font-awesome-icon>
                        {{ t("message.colorRemove") }}
                      </button>
                      <button
                        class="btn btn-outline-lcn"
                        @click="showPicker = false"
                      >
                        <font-awesome-icon
                          :icon="['far', 'eye-slash']"
                          class="icon"
                        ></font-awesome-icon>
                        {{ t("message.fadeOut") }}
                      </button>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
            <div class="row mt-3 text-start">
              <div class="col-5">{{ t("message.colorSamples") }}</div>
              <div class="col-7">
                <img
                  src="@/assets/images/leds/blueredgrad.png"
                  alt=""
                  style="cursor: pointer"
                  @click="colorBarG('bluered')"
                />
                <img
                  src="@/assets/images/leds/greygreengrad.png"
                  alt=""
                  style="cursor: pointer"
                  @click="colorBarG('greygreen')"
                />
                <img
                  src="@/assets/images/leds/greyyellowgrad.png"
                  @click="colorBarG('greyyellow')"
                  alt=""
                  style="cursor: pointer"
                />
                <img
                  src="@/assets/images/leds/white.png"
                  alt=""
                  style="border: 1px solid grey; cursor: pointer"
                  @click="colorBarG('white')"
                />
              </div>
            </div>
            <div class="row text-start mt-3">
              <div class="col-7 offset-5">
                <button
                  class="btn btn-outline-lcn"
                  v-if="showBarG"
                  @click="toggleBarG"
                >
                  <font-awesome-icon
                    :icon="['far', 'eye-slash']"
                    class="icon"
                  ></font-awesome-icon>
                  {{ t("message.fadeOut") }}
                </button>
              </div>
            </div>
          </template>
        </div>
      </li>
    </template>
  </ul>
</template>

<script>
import { useStore } from "vuex";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import MyCp from "@/views/editors/editor-components/ColorPicker.vue";
import { selectedBarG } from "../../store/getters";
export default {
  components: {
    MyCp,
  },
  setup() {
    const store = useStore();
    const ledRad = computed(() => store.getters.currentLEDRad);
    const showLEDs = computed(() => store.getters.showLEDs);
    const showBarG = computed(() => store.getters.showBarG);
    const currentInlay = computed(() => store.getters.currentInlay);
    const currentBargraph = computed(() => store.getters.selectedBarG);
    const selectedBarGLEDs = computed(() => store.getters.selectedBarGLEDs);
    const currentProject = computed(() => store.getters.currentProject);
    const smallKeys = computed(() => store.getters.smallKeys);
    const showPicker = ref(false);
    const { t } = useI18n();
    function toggleLEDs() {
      // showLEDs.value = !showLEDs.value;
      store.dispatch("toggleLEDs", !showLEDs.value);
    }
    function changeRad(rad) {
      store.dispatch("setLEDrad", rad + "px");
    }
    function toggleBarG() {
      if (smallKeys.value) {
        let revert = confirm(t("message.revertKeys"));
        if (revert) {
          store.commit("setRevertKeys", {
            group: currentInlay.value.group,
            name: currentInlay.value.name,
          });
        }
        store.commit("setSmallKeys", false);
      }
      store.dispatch("toggleBarG", !showBarG.value);
      store.commit("setSelectedBarGLEDsEmpty");
    }
    function changeBarGraph(graph) {
      store.dispatch("selectBarG", graph);
    }
    function updateColor(event) {
      selectedBarGLEDs.value.forEach((led) => {
        let ledIdx = currentInlay.value.inlay.bargraph.findIndex(
          (bled) => led.id == bled.id
        );
        let selIdx = currentBargraph.value.findIndex(
          (selLed) => led.id == selLed.id
        );
        store.dispatch("changeBargraphColor", {
          index: ledIdx,
          color: event.colors.hex,
        });
        currentBargraph.value[selIdx].style["background-color"] =
          event.colors.hex;
      });
    }
    function colorBarG(value) {
      let br = [
        "#FF0000",
        "#EB0813",
        "#E50A1A",
        "#CE1331",
        "#B31E4B",
        "#AB2155",
        "#8E2B71",
        "#7E3381",
        "#75258A",
        "#623D9D",
        "#4D45B2",
        "#3B4DC5",
        "#115DEE",
        "#095FF6",
        "#0363FD",
      ];
      let gg = [
        "#57FA2C",
        "#4FEE27",
        "#3FD51A",
        "#34C313",
        "#2BB40C",
        "#22A606",
        "#1C9B02",
        "#158E00",
        "#107B00",
        "#107100",
        "#106600",
        "#155C07",
        "#225418",
        "#3C493A",
        "#444544",
      ];
      let gy = [
        "#FEDD00",
        "#FBD600",
        "#F7CC00",
        "#ECBB00",
        "#E1B000",
        "#D7A701",
        "#CEA005",
        "#BE950C",
        "#B08B12",
        "#A08019",
        "#937820",
        "#79672C",
        "#6B573D",
        "#625838",
        "#454545",
      ];
      let colors = [];
      switch (value) {
        case "bluered":
          colors = br;
          break;
        case "greygreen":
          colors = gg;
          break;
        case "greyyellow":
          colors = gy;
          break;
      }
      currentBargraph.value.forEach((led, index) => {
        let ledIdx = currentInlay.value.inlay.bargraph.findIndex(
          (bled) => led.id == bled.id
        );
        let selIdx = currentBargraph.value.findIndex(
          (selLed) => led.id == selLed.id
        );

        if (value != "white") {
          store.dispatch("changeBargraphColor", {
            index: ledIdx,
            color: colors[index],
          });
          currentBargraph.value[selIdx].style["background-color"] =
            colors[index];
        } else {
          store.dispatch("changeBargraphColor", {
            index: ledIdx,
            color: "white",
          });
          currentBargraph.value[selIdx].style["background-color"] = "white";
        }
      });
    }
    function changeColor(e) {
      // updateBtn("background", e);
      //console.log(e);
    }
    function mouseUp() {
      store.dispatch("saveInlay");
    }

    const selectedLEDs = computed(() => store.getters.selectedLEDs);
    const ledsHidden = ref(false);
    function hideSelectedLEDs() {
      store.commit("hideSelectedLEDs");
      ledsHidden.value = true;

      // console.log(currentInlay.value);
    }
    return {
      ledRad,
      showLEDs,
      toggleLEDs,
      toggleBarG,
      changeRad,
      showBarG,
      currentInlay,
      changeBarGraph,
      updateColor,
      currentBargraph,
      selectedBarGLEDs,
      showPicker,
      t,
      colorBarG,
      changeColor,
      mouseUp,
      selectedLEDs,
      ledsHidden,
      hideSelectedLEDs,
    };
  },
};
</script>

<style lang="scss" scoped>
.bargraph-select {
  height: 5px !important;
  display: none;
}
</style>
